import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Table,
  Container,
} from "reactstrap";
import { toast } from "react-toastify";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const TemperatureAlarm = () => {
  const [tempData, setTempData] = useState([]);
  const [alarmList, setAlarmList] = useState([]);
  const [loading, setLoading] = useState(false);
const [machines, setMachines] = useState([]);
const [selectedMachine, setSelectedMachine] = useState("");
const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0] // YYYY-MM-DD
);
const fetchMachines = async () => {
  try {
    const res = await axios.get("https://api.hanoch.in/api/machines/by-company/?id=6");
    const machineList = res.data || [];
    setMachines(machineList);
console.log("mm",machineList)
    if (machineList.length > 0) {
      setSelectedMachine(machineList[0].name); // 👈 default first
    }
  } catch (err) {
    toast.error("Failed to load machines");
  }
};
useEffect(() => {
  fetchMachines();
  // fetchAlarmList();
}, []);

useEffect(() => {
  if (!selectedMachine || !selectedDate) return;

  fetchTemperatureTrend();

  const intervalId = setInterval(() => {
    fetchTemperatureTrend();
  }, 60 * 1000);

  return () => clearInterval(intervalId);
}, [selectedMachine, selectedDate]);

// useEffect(() => {
//   // initial fetch
//   fetchTemperatureTrend();
//   fetchAlarmList();

//   // fetch temperature trend every 1 minute
//   const intervalId = setInterval(() => {
//     fetchTemperatureTrend();
//   }, 60 * 1000); // 1 minute

//   // cleanup on unmount
//   return () => clearInterval(intervalId);
// }, []);
const generateFullDayTimeline = () => {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m++) {
      times.push({
        time: `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`,
        temperature: null,
      });
    }
  }
  return times;
};
// const fetchTemperatureTrend = async () => {
//   try {
//     setLoading(true);

//     const res = await axios.get(
//       `https://api.hanoch.in/api/ptc/telemetry/?machine=${selectedMachine}&date=${selectedDate}`
//     );

//     const apiData = res.results || [];
//     const fullTimeline = generateFullDayTimeline();

//     const now = new Date();
//     const isToday =
//       selectedDate === new Date().toISOString().split("T")[0];

//     const mergedData = fullTimeline.map(point => {
//       const match = apiData.find(d => d.time === point.time);

//       if (match) {
//         return {
//           time: point.time,
//           temperature: match.temperature,
//         };
//       }

//       // 🚫 future → null (line stops)
//       if (isToday) {
//         const pointTime = new Date(`${selectedDate}T${point.time}`);
//         if (pointTime > now) {
//           return { ...point, temperature: null };
//         }
//       }

//       return point;
//     });

//     setTempData(mergedData);
//   } catch (err) {
//     toast.error("Failed to load temperature trend");
//   } finally {
//     setLoading(false);
//   }
// };

  // const fetchTemperatureTrend = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await axios.get(
  //       `https://api.hanoch.in/api/ptc/telemetry/?machine=${selectedMachine}&date=${selectedDate}`
  //     );
  //     setTempData(res.results || []);
  //   } catch (err) {
  //     toast.error("Failed to load temperature trend");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchAlarmList = async () => {
    try {
      const res = await axios.get(
        "https://api.yourdomain.com/temperature-alarms"
      );
      setAlarmList(res.data || []);
    } catch (err) {
      toast.error("Failed to load alarm list");
    }
  };


  const fetchTemperatureTrend = async () => {
  try {
    setLoading(true);

    const res = await axios.get(
      `https://api.hanoch.in/api/ptc/telemetry/?machine=${selectedMachine}&date=${selectedDate}`
    );

    const cleanedData = (res.results || []).map(item => ({
      ...item,
      temperature:
        item.temperature === 0 ? null : item.temperature,
    }));

    setTempData(cleanedData);
  } catch (err) {
    toast.error("Failed to load temperature trend");
  } finally {
    setLoading(false);
  }
};

const exportToExcel = () => {
  if (!tempData.length) {
    toast.warning("No data to export");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(tempData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Temperature");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(
    blob,
    `Temperature_${selectedMachine}_${selectedDate}.xlsx`
  );
};
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Temperature Trend" />

          {/* ===== Temperature Graph Section ===== */}
          <Row>
            <Col lg={12}>
              <Card>
               <CardHeader className="d-flex justify-content-between align-items-center">
  <h5 className="mb-0">Temperature vs Time</h5>
<Row>
  <Col lg={4}>
  <div className="">
    <select
      className="form-select"
      value={selectedMachine}
      onChange={(e) => setSelectedMachine(e.target.value)}
    >
      {machines.map((m) => (
        <option key={m.id} value={m.name}>
         Freezer 1
        </option>
      ))}
    </select>
</div>
</Col>
<Col lg={4}>
    <input
      type="date"
      className="form-control"
      value={selectedDate}
      onChange={(e) => setSelectedDate(e.target.value)}
    />
</Col>
<Col lg={4}>
    <button
      className="btn btn-outline-success"
      onClick={exportToExcel}
    >
      Export Excel
    </button>
    </Col>
</Row>
</CardHeader>

                <CardBody style={{ height: 350 }}>
                  <ResponsiveContainer width="100%" height="100%">
                   <LineChart data={tempData}>
              <CartesianGrid stroke="#e0e0e0" strokeDasharray="3 3" />       
  <XAxis
    dataKey="time"
    interval={59}                 // one tick per hour
    tickFormatter={(t) => t.slice(0, 5)}
    axisLine={{ stroke: "#aaa" }}  
    tickLine={true}
  />
  <YAxis   axisLine={{ stroke: "#aaa" }}  tickLine={true} />
  <Tooltip />
  <Line
    type="monotone"
    dataKey="temperature"
    dot={false}
    strokeWidth={2}
    connectNulls={false}          // 👈 KEY
  />
</LineChart>

                  </ResponsiveContainer>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ===== Alarm List Section ===== */}
          {/* <Row className="mt-3">
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="mb-0">Temperature Alarms</h5>
                </CardHeader>
                <CardBody>
                  <Table bordered responsive hover>
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Time</th>
                        <th>Temperature</th>
                        <th>Alarm Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {alarmList.length > 0 ? (
                        alarmList.map((alarm, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{alarm.time}</td>
                            <td>{alarm.temperature} °C</td>
                            <td>{alarm.message}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No alarms found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TemperatureAlarm;
